import { render } from "./AdminSysLogsTab.vue?vue&type=template&id=6decdb6c&ts=true"
import script from "./AdminSysLogsTab.vue?vue&type=script&lang=ts"
export * from "./AdminSysLogsTab.vue?vue&type=script&lang=ts"

import "./AdminSysLogsTab.vue?vue&type=style&index=0&id=6decdb6c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__